import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useProjectCategoryUIContext } from "./ProjectCategoryUIContext";
import ProjectCategoryTable from "./project-category-table/ProjectCategoryTable";
// import { ProjectFilter } from "./project-filter/ProjectFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const ProjectCategoryCard = () => {
  const projectCategoryUIContext = useProjectCategoryUIContext();
  const projectCategoryUIProps = useMemo(() => {
    return {
      newProjectCategoryButtonClick: 
        projectCategoryUIContext.newProjectCategoryButtonClick,
    };
  }, [projectCategoryUIContext]);

  return (
    <Card>
      <CardHeader title="Daftar Kategori Penyaluran">
        <CardHeaderToolbar>
          {BlockOrg() && RoleChecker("Create", "project") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={projectCategoryUIProps.newProjectCategoryButtonClick}
            >
              Kategory Penyaluran Baru
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* <ProjectFilter /> */}
        <ProjectCategoryTable />
      </CardBody>
    </Card>
  );
};
